import {PaginationModel} from '@core/models/pagination.model';

export class FilterUserRequest extends PaginationModel{
  name:string = null;
  userName: string = null;
  email: string = null;
  phoneNumber?: string = null;
  status?: number = -1;
  userRole?: string = 'ALL';
}

export interface EditUserRequest {
  id?: number,
  userName?: string,
  name: string,
  email: string,
  phoneNumber: string,
  status?: number,
  userRole: string,
  password?: string,
}
